import DateTimeOffset from "sap/ui/model/odata/type/DateTimeOffset";

export function odataEnumToString(enumValue: string, enumName: string) {
    return "VAMOS." + enumName + "'" + enumValue + "'";
}
